module.exports = __webpack_public_path__ + "static/changeling_1-09772c939992bd3f0f7621e2021ac8d0.png";